const template = `
	<div class="pie-chart">
		<div class="chart-inner">
			<highcharts
				:key="renderKey"
				v-if="data"
				:options="opts"
			></highcharts>
			<div v-else class="loading-label">{{ ii('LOADING') }}...</div>
		</div>
	</div>
`;

export default {
	template,
	props: ['title', 'data', 'tooltip-unit'],
	data() {
		return {
			renderKey: 0
		};
	},
	computed: {
		opts() {
			let v = this;

			let opts = {
				chart: {
					type: 'pie',
					spacingTop: 35,
					marginTop: 85,
					style: {
						fontFamily: 'Roboto, "Open Sans", sanf-serif, helvetica, tahoma, verdana'
					}
				},
				title: {
					text: this.title,
					style: {
						textTransform: 'uppercase',
						fontWeight: 500
					}
				},
				colors: this.app.theme === 'modern'
					? ['#0288d1', '#10b981', '#f59e0b', '#8b5cf6', '#0f172a', '#06b6d4', '#ef4444', '#64748b', '#42b9f4', '#c9a400']
					: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
				tooltip: {
					hideDelay: 100,
					headerFormat: '',
					pointFormatter() {
						let val = v.util.numFormat(this.y);
						let percent = v.util.numFormat(this.percentage, '', 2);
						return `
							<span>
								<span style="color:${this.color}">●</span> ${this.name}
							</span>
							<br>
							<span>${v.tooltipUnit}: <b>${val}</b> (${percent}%)</span>
						`;
					}
				},
				legend: {
					align: 'center'
				},
				series: [{
					name: this.title,
					data: this.limitedData
				}]
			};
			return opts;
		},
		// keep the pie readable: top 12 slices + "Other" (only in the modern theme)
		limitedData() {
			let data = this.data;
			if (this.app.theme !== 'modern' || !Array.isArray(data) || data.length <= 14) return data;

			let getY = p => (p && typeof p === 'object') ? (p.y || 0) : (Array.isArray(p) ? (p[1] || 0) : 0);
			let sorted = [...data].sort((a, b) => getY(b) - getY(a));
			let top = sorted.slice(0, 12);
			let rest = sorted.slice(12);
			let otherSum = rest.reduce((sum, p) => sum + getY(p), 0);
			if (otherSum > 0) {
				top.push({name: 'Other (' + rest.length + ')', y: otherSum, color: '#cbd5e1'});
			}
			return top;
		}
	},
	watch: {
		'app.lang'() {
			this.renderKey++;
		}
	}
}